module.exports = __webpack_public_path__ + "static/undivided-logo-69a5cb35639bb0d7c9b26e4f85e19e92.png";